import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@chakra-ui/react';
import { useEmbeddedEffect } from '@machinemetrics/mm-react-embeddable';
import MMEmbeddableZoneWithLoader from 'components/MMEmbeddableZoneWithLoader';
import { APM_SELECT_JOBS_HOST } from 'lib/appConfig';

const ZONE_ID = 'apm-select-jobs-multi';

/**
 * Pallet multi-job selection via apm-select-jobs MFE (grid → prepare → start-jobs).
 */
const MultiJobSelectFlow = ({
  machineRef,
  machineId,
  erpResources,
  onCancel,
  onComplete,
}) => {
  const handleEmbeddedCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleJobSelected = useCallback(
    (data) => {
      window.dispatchEvent(new CustomEvent('apm:opdash-refresh'));
      if (onComplete) {
        onComplete(data);
      }
    },
    [onComplete]
  );

  useEmbeddedEffect(ZONE_ID, 'apm-select-jobs:cancel', handleEmbeddedCancel);
  useEmbeddedEffect(ZONE_ID, 'apm-select-jobs:job-selected', handleJobSelected);

  if (!APM_SELECT_JOBS_HOST) {
    return (
      <Box flex={1} p={6}>
        <Text color="red.500" fontWeight="medium">
          Job selection is not configured for this environment (missing
          apm-select-jobs host).
        </Text>
      </Box>
    );
  }

  return (
    <Box position="relative" flex={1} minH={0} h="full" overflow="hidden">
      <MMEmbeddableZoneWithLoader
        id={ZONE_ID}
        src={APM_SELECT_JOBS_HOST}
        path="/"
        context={{
          machineRef,
          machineId,
          erpResources,
          selectionMode: 'multi',
        }}
      />
    </Box>
  );
};

MultiJobSelectFlow.propTypes = {
  machineRef: PropTypes.number,
  machineId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  erpResources: PropTypes.arrayOf(PropTypes.string),
  onCancel: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
};

MultiJobSelectFlow.defaultProps = {
  machineRef: undefined,
  machineId: undefined,
  erpResources: undefined,
  onComplete: undefined,
};

export { MultiJobSelectFlow };
